var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.59593 0 5.62756 1.97277 5.62756 4.38222V6.57591H3.71046C2.36233 6.57591 1.25 7.68559 1.25 9.04187L1.25 17.534C1.25 18.8903 2.36233 20 3.71046 20H16.2895C17.6377 20 18.75 18.8903 18.75 17.534V9.04187C18.75 7.68559 17.6377 6.57591 16.2895 6.57591H14.3724V4.38222C14.3724 1.97277 12.4041 0 10 0ZM10 1.64398C11.5173 1.64398 12.7321 2.86155 12.7321 4.38222V6.57591H7.26787V4.38222C7.26787 2.86155 8.48272 1.64398 10 1.64398ZM3.71046 8.21988H16.2895C16.7509 8.21988 17.1097 8.57436 17.1097 9.04187V17.534C17.1097 18.0015 16.7509 18.356 16.2895 18.356H3.71046C3.24912 18.356 2.8903 18.0015 2.8903 17.534V9.04187C2.8903 8.57436 3.24912 8.21988 3.71046 8.21988Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.38227130.svg";
export { ForwardRef as ReactComponent };